import { render, staticRenderFns } from "./UserCard2.vue?vue&type=template&id=dc512114&scoped=true"
import script from "../../../scripts/partials/cards/UserCard2.js?vue&type=script&lang=js&external"
export * from "../../../scripts/partials/cards/UserCard2.js?vue&type=script&lang=js&external"
import style0 from "./UserCard2.vue?vue&type=style&index=0&id=dc512114&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc512114",
  null
  
)

export default component.exports